import React from 'react';
import './landing.css';
import Header from './Header';
import Hero from './Hero';
import Features from './Features';
import HowItWorks from './HowItWorks';
import FAQ from './FAQ';
import Footer from './Footer';

const Landing: React.FC = () => {
  return (
    <div className="landing-page">
      <Header />
      <Hero />
      <Features />
      <HowItWorks />
      <FAQ />
      <Footer />
    </div>
  );
};

export default Landing;
